/* eslint-disable require-jsdoc */
import {library, icon} from '@fortawesome/fontawesome-svg-core';
import {faFacebook, faTwitter, faInstagram, faBandcamp,
  faYoutube, faSpotify, faSoundcloud,
  faDeezer} from '@fortawesome/free-brands-svg-icons';

library.add(faFacebook, faTwitter, faInstagram, faBandcamp, 
            faYoutube, faSpotify, faSoundcloud, faDeezer);
const facebookIcon = icon({ prefix: 'fab', iconName: 'facebook' }).html;
const twitterIcon = icon({ prefix: 'fab', iconName: 'twitter' }).html;
const instagramIcon = icon({ prefix: 'fab', iconName: 'instagram' }).html;
const bandcampIcon = icon({ prefix: 'fab', iconName: 'bandcamp' }).html;
const youtubeIcon = icon({ prefix: 'fab', iconName: 'youtube' }).html;
const spotifyIcon = icon({ prefix: 'fab', iconName: 'spotify' }).html;
const soundCloudIcon = icon({ prefix: 'fab', iconName: 'soundcloud' }).html;
const deezerIcon = icon({ prefix: 'fab', iconName: 'deezer' }).html;

const bandSocialMedia = [
  'Facebook',
  'Twitter',
  'Instagram',
  'Bandcamp',
  'Youtube',
  'Spotify',
  'SoundCloud',
  'Deezer',
];

const bandSocialMediaIcons = [
  facebookIcon,
  twitterIcon,
  instagramIcon,
  bandcampIcon,
  youtubeIcon,
  spotifyIcon,
  soundCloudIcon,
  deezerIcon,
];

function getBandSocialName(typeId) {
  return bandSocialMedia[parseInt(typeId) - 1];
}

function getBandSocialIconName(typeId) {
  return bandSocialMediaIcons[parseInt(typeId) - 1];
}

function getBandSocialIcon(bandSocial) {
  const uppercaseSocial = getBandSocialName(bandSocial.typeId);
  const socialIconImage = getBandSocialIconName(bandSocial.typeId);
  const lowercaseSocial = uppercaseSocial.toLowerCase();
  const socialAddress = bandSocial.address;
  return `<div class="hearby-grid-item">
            <a class="hearby-icon hearby-social-icon 
              hearby-social-icon-${lowercaseSocial}" 
              href="${socialAddress}" target="_blank"
              target="_blank">
              <span class="hearby-screen-only">${uppercaseSocial}</span>
              ${socialIconImage} 
            </a>
          </div>`;
}
function getBandSocialIcons(bandSocialArr) {
  let bandSocialHtml = '';
  bandSocialArr.forEach(
      (bandSocial) => (bandSocialHtml += getBandSocialIcon(bandSocial)),
  );
  return `<div class="hearby-social-icons-wrapper 
            hearby-grid heda-social">
            ${bandSocialHtml}
          </div>`;
}
function hasSocial(band) {
  return band.bandSocialMedia.length ? true : false;
}
export {getBandSocialIcons, hasSocial};
